module.exports = __webpack_public_path__ + "static/media/1.ce909e7b.jpg";